import * as Sentry from '@sentry/react';
import { ENVIRONMENT } from '@/utils/constants';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export function initSentry(): void {
  if (!SENTRY_DSN) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: ENVIRONMENT === 'production' ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (ENVIRONMENT === 'development') return null;
      return event;
    },
  });
}

export function captureError(error: unknown, context?: Record<string, unknown>): void {
  if (!SENTRY_DSN) return;
  Sentry.captureException(error, { extra: context });
}

export function setUserContext(user: { id: string; email?: string }): void {
  Sentry.setUser({ id: user.id, email: user.email });
}

export function clearUserContext(): void {
  Sentry.setUser(null);
}
